import React from 'react';

interface LoginShellProps {
  children?: React.ReactNode;
}

const Login: React.FC<LoginShellProps> = ({ children }) => {
  return <div className="m-auto grid max-w-300 px-16" data-testid="login">{children}</div>;
};

export default Login;
